import { ColDef, ValueGetterParams } from 'ag-grid-community'
import { formatDMY, parseToIsoUtc } from 'pages/ManageBackUpPage/helperFns'

interface AssignmentRowData {
  markets?: string
  countryCodes?: string
  roleTitle?: string
  backupApproverEmail?: string
  backupBeginDate?: string
  backupEndDate?: string
  // Add other fields as needed
}

const assignmentsColumnDefs = [
  {
    headerName: '',
    colId: 'deleteColumn',
    minWidth: 60,
    width: 80,
    pinned: 'left',
    sortable: false,
    filter: false,
    suppressMenu: true,
    headerComponent: 'deleteHeaderRenderer',
    cellClass: 'ag-center-cols-container',
    cellRenderer: 'deleteCellRenderer',
  },
  {
    headerName: 'Markets',
    field: 'markets',
    minWidth: 60,
    width: 140,
    hide: false,
    headerTooltip: 'Markets',
    tooltipField: 'markets',
    tooltipValueGetter: (params: ValueGetterParams<AssignmentRowData>) => {
      return params.data?.markets
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'Country',
    field: 'countryCodes',
    width: 400,
    headerTooltip: 'Country',
    tooltipField: 'countryCodes',
    tooltipValueGetter: (params: ValueGetterParams<AssignmentRowData>) => {
      return params.data?.countryCodes
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'Approver Group',
    field: 'roleTitle',
    width: 280,
    headerTooltip: 'Approver Group',
    tooltipField: 'roleTitle',
    tooltipValueGetter: (params: ValueGetterParams<AssignmentRowData>) => {
      return params.data?.roleTitle
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
    alwaysShowTooltip: true,
    showTooltip: true,
  },
  {
    headerName: 'Assigned To',
    width: 280,
    field: 'backupApproverEmail',
    headerTooltip: 'Assigned To',
    tooltipField: 'backupApproverEmail',
    tooltipValueGetter: (params: ValueGetterParams<AssignmentRowData>) => {
      return params.data?.backupApproverEmail
    },
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'Begin Date',
    width: 140,
    field: 'backupBeginDate',
    headerTooltip: 'Begin Date',
    tooltipField: 'backupBeginDate',
    valueFormatter: (p: any) => formatDMY(p.value),
    tooltipValueGetter: (p: any) => formatDMY(p.data?.backupBeginDate),
    valueParser: (p: any) => parseToIsoUtc(p.newValue, p.oldValue),
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
  {
    headerName: 'End Date',
    width: 140,
    field: 'backupEndDate',
    headerTooltip: 'End Date',
    tooltipField: 'backupEndDate',
    valueFormatter: (p: any) => formatDMY(p.value),
    tooltipValueGetter: (p: any) => formatDMY(p.data?.backupEndDate),
    valueParser: (p: any) => parseToIsoUtc(p.newValue, p.oldValue),
    tooltipComponentParams: {
      alwaysShowTooltip: true,
      hide: true,
    },
  },
]

export default assignmentsColumnDefs as ColDef[]
